import PropTypes from 'prop-types'
import { Box, Card, Typography } from '@mui/material'
import ProgressMetric from './ProgressMetric'
import { formatDuration } from '../Utils/utils'
import { metricDataPropType } from '../Utils/types'

export default function CardMetric({ icon, label, data, colour }) {
  const { value, target } = data
  const percentage = target > 0 ? Math.round((value / target) * 100) : 0
  const isTalkTime = label?.toLowerCase() === 'talk time'
  const displayValue = isTalkTime ? formatDuration(value) : value
  const displayTarget = isTalkTime ? formatDuration(target) : target

  const Icon = icon

  return (
    <Card
      sx={{
        p: 2,
        bgcolor: 'action.hover',
        color: 'text.primary',
        borderRadius: 3,
        mb: 2,
      }}
    >
      <Box display="flex">
        <Box
          mr={2}
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{
            fontSize: 30,
            width: 40,
          }}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <Icon sx={{ fontSize: 24, colour }} />
          </Box>
        </Box>

        <Box flexGrow={1}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              lineHeight: 1,
            }}
          >
            {displayValue}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: 'text.secondary',
              mt: 1,
            }}
          >
            {label}
          </Typography>
        </Box>

        <Box textAlign="right">
          <Typography
            variant="body1"
            sx={{
              color: 'text.secondary',
            }}
          >
            Target: {displayTarget}
          </Typography>

          <Typography
            variant="h5"
            sx={{
              color: colour,
              fontWeight: 700,
            }}
          >
            {`${percentage}%`}
          </Typography>
        </Box>
      </Box>

      <Box mt={3}>
        <ProgressMetric label={label} data={data} colour={colour} height={8} />
      </Box>
    </Card>
  )
}

CardMetric.propTypes = {
  icon: PropTypes.elementType.isRequired,
  label: PropTypes.string.isRequired,
  colour: PropTypes.string.isRequired,
  data: metricDataPropType.isRequired,
}
